enum NuvemEnvioAppCode {
  AR = 'envo-nube-argentina', // This is not a typo. Do not change please.
  MX = 'envo-nube', // This is not a typo. Do not change please.
  BR = 'nuvem-envio',
}

export default NuvemEnvioAppCode;
